export const statusList = (t: any) => {
  return [
    {
      value: 'all',
      label: t('h128'),
    },
    {
      value: 'APD',
      label: t('h129'),
    },
    {
      value: 'RJC',
      label: t('h130'),
    },
    {
      value: 'CND',
      label: t('h131'),
    },
    {
      value: 'AWT',
      label: t('h132'),
    },
  ]
}
